<template>
  <div class="slider">
    <b-row class="no-gutters">
      <b-col cols="1" class="text-center slider-arrow">
        <font-awesome-icon icon="angle-left" />
      </b-col>
      <b-col v-if="cars.length > 1">
        <b-row class="no-gutters">
          <b-col
            cols="3"
            md="2"
            v-for="car in cars"
            :key="car.id"
            v-on:click="selectCar(car.id)"
          >
            <b-img-lazy
              :src="car.pictures_main[0] | imageMedium"
              fluid-grow
              class="slide"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="1" class="text-center slider-arrow">
        <font-awesome-icon icon="angle-right" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

library.add(faAngleLeft, faAngleRight);

export default {
  name: "CarsSlider",
  props: {
    cars: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  filters: {
    imageMedium: function (image) {
      return (
        "https://db97aqbgbmp5i.cloudfront.net/images/inv/small/" + image
      );
    },
  },
  mounted: function () {
    if (this.cars.length === 0) return;
    this.$emit("select-car", this.cars[0].id);
  },
  methods: {
    selectCar: async function (carId) {
      this.$emit("select-car", carId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.slider {
  background-color: $white;
}

.slider-arrow {
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  display: none;
}

.slide {
  cursor: pointer;
}
</style>
